import { getMFHProcess, updateMfhProcess } from '@/api/mfh';
import { withLoading } from '@/shared';
import { useMutation, useQuery } from '@tanstack/vue-query';
import type { MaybeRef } from 'vue';
import { computed, unref } from 'vue';

export const useMfhProcess = (queryOrRef?: MaybeRef<{ mfhId: number; processType: MFHProcessType; processId: number }>, enabled: MaybeRef<boolean> = true) => {
    const queryValue = computed(() => unref(queryOrRef));
    const enabledValue = computed(() => unref(enabled));

    const query = useQuery(
        ['mfh-process', queryValue.value.mfhId, queryValue.value.processType, queryValue.value.processId],
        async (): Promise<IMFHProcess> => withLoading(async () => getMFHProcess(queryValue.value)),
        {
            initialData: null,
            enabled: enabledValue.value,
        },
    );

    const { mutateAsync: updateMFHProcessMutation } = useMutation(
        async (data: IUpdateMFHProcessReq.Body) => withLoading(async () => updateMfhProcess(queryValue.value, data)),
        {
            onSuccess: () => query.refetch(),
        },
    );

    return { ...query, updateMFHProcess: updateMFHProcessMutation };
};
